import * as api from '../api'
import { UPDATE_UPDOWNVOTE_TOTAL, STORE_PROGRESS_UPDOWNVOTE,  DELETE_COMMENT_REPLY, EDIT_COMMENT_REPLY, EDIT_COMMENT} from '../constants/actionConstants';
import { COMMENT_DISCUSSION, COMMENT_ERRATA, COMMENT_EXPLAIN, COMMENT_QUESTION } from '../constants/commentsConstants';
import { getAIReplyStream } from '../api/stream';


function escapeMathBackslashes(input) {
    return input.replace(/(\${1,2})([\s\S]*?)(\1)/g, (_, delimiter, content, closing) => {
      // Replace single backslashes that are NOT already part of a double
      const escapedContent = content.replace(/(^|[^\\])\\(?!\\)/g, '$1\\\\');
      return `${delimiter}${escapedContent}${closing}`;
    });
  }

  function normalizeNewlines(input) {
    return input.replace(/\n{2,}\$/g, '\n\$').replace(/\$\n{2,}/g, '\$\n');
  }


export const clean_up_ai_response=(response)=>{
    // Strip out json header
    response = response.replaceAll("```","")
    response = response.replaceAll("json","")
    // Move punctuation inside equations
    response = response.replace(/\$\$\./g, '.$$');
    response = response.replace(/\$\$,/g, ',$$')
    // Do some massaging of the response
    response = escapeMathBackslashes(response) ; 
    response = normalizeNewlines(response) ; 

    // Replace double backslashes with single and two spaces
    response = response.replace(/\\n/g, '  \n');

    return response ; 
}

export const addComment = (course_id, section_index, content_id, newComment, frame_text) => async (dispatch) => {
        
    try{
        // Note local copy in reducer has already been submitted by routine that calls this.
        var update_comment_details  = {}
        update_comment_details["newComment"] = newComment // Details of comment
        update_comment_details["content_id"] = content_id // ID of content item to add to
        update_comment_details["frame_text"] = frame_text // Text from frame


        // Stream if explain comment
        if(newComment.type===COMMENT_EXPLAIN)
        {
            var full_response = "" ;
            await getAIReplyStream(course_id, { course_id, update_comment_details }, (chunk) => {
                    full_response += chunk;
                    var edited_comment = structuredClone(newComment)
                    edited_comment.children[0].contents = full_response 
                    dispatch({type: EDIT_COMMENT, payload: {section_index, editedComment:edited_comment}}) ; 
                });
        }
        else{
            var full_response = "" ;
            console.log("Calling getAIReply Stream")
            await getAIReplyStream(course_id, { course_id, update_comment_details }, (chunk) => {
                full_response += chunk;
                var edited_comment = structuredClone(newComment)

                // We are gradually reading a partial json file
                // Retrieve fields set edited comment from last part when it arrives

                // Find if the type is present
                const match = full_response.match(/"type"\s*:\s*"([^"]*)"/);
                // If the type is a question
                if(match){
                    if(match[1]==="QUESTION" || match[1]==="COMMENT"){
                        // Test if response is complete
                        edited_comment.type = match[1]==="QUESTION" ? COMMENT_QUESTION : COMMENT_DISCUSSION ; 
                        const match4 = full_response.match(/"title"\s*:\s*"([^"]*)"/);
                        // Add in the AI summary title if we have read it
                        if(match4){
                            edited_comment.title=match4[1] ; 
                        }

                        const match2 = full_response.match(/"response"\s*:\s*"([^"]*)"/);
                        if(match2){
                            edited_comment.children[0].contents = clean_up_ai_response(match2[1])
                            dispatch({type: EDIT_COMMENT, payload: {section_index, editedComment:edited_comment}}) ; 
                        }
                        else{
                            // Deal with partial response
                            const match3 = full_response.match(/"response"\s*:\s*"([^"]*)/);
                            if(match3){
                                
                                edited_comment.children[0].contents = clean_up_ai_response(match3[1]) ; 
                                dispatch({type: EDIT_COMMENT, payload: {section_index, editedComment:edited_comment}}) ; 
                            }
                        }
                    }
                    else{
                        if(match[1]==="ERRATUM")
                        edited_comment.type = COMMENT_ERRATA ; 
                        edited_comment.children[0].contents = "Thanks!  We'll look into that and fix it if appropriate."
                        dispatch({type: EDIT_COMMENT, payload: {section_index, editedComment:edited_comment}}) ; 
                    }
                }
            });
        }

    } catch (error) {
        console.log(error) ;
    }
}


export const addCommentReplyAI = (course_id, section_index, content_id, reply, child_indices, comment_id, frame_text, comment_history, child_indices_reply) => async (dispatch) => {

     // Note local copy in reducer has already been submitted by routine that calls this.
    var update_comment_details  = {}
    update_comment_details["reply"] = reply // Details of comment
    update_comment_details["content_id"] = content_id // ID of content item to add to
    update_comment_details["comment_id"] = comment_id // The ID of the original comment
    update_comment_details["child_indices"] = child_indices
    update_comment_details["frame_text"] = frame_text // Text from frame
    update_comment_details["comment_history"] = comment_history // History of previous comments

    var full_response = "" ;
    await getAIReplyStream(course_id, { course_id, update_comment_details }, (chunk) => {
        full_response += chunk;
        const edit_data = {contents: full_response, date:reply.date} 
        dispatch({type: EDIT_COMMENT_REPLY, payload: {edit_data, content_id, comment_id, child_indices:child_indices_reply}}) ;  
    });
}


export const addCommentReply = (course_id, content_id, reply, child_indices, comment_id) => async (dispatch) => {
    try{    
        // Note local copy in reducer has already been submitted by routine that calls this.

        var update_comment_details  = {}
        update_comment_details["reply"] = reply // The new comment
        update_comment_details["content_id"] = content_id // The ID of the content item (to look up in database)
        update_comment_details["comment_id"] = comment_id // The ID of the original comment
        update_comment_details["frame_text"] = "" // Text from frame (dummy to let backend know that no AI is required)
        update_comment_details["child_indices"] = child_indices
        console.log(child_indices)
        // // This sends same info to database
        await api.addCommentReply(course_id, update_comment_details) ; 
    } catch (error) {
        console.log(error) ;
    }
}



export const editComment = (course_id, section_index, content_id, editedComment) => async (dispatch) => {
    try{
        // This is received internally by reducer (will happen quickly)
        dispatch({type: EDIT_COMMENT, payload: {section_index, editedComment}}) ; 
        var edit_comment_details  = {}
        edit_comment_details["newComment"] = editedComment // Details of comment
        edit_comment_details["content_id"] = content_id // ID of content item to add to
        // This sends same info to database
        await api.editComment(course_id, edit_comment_details) ; 
    } catch (error) {
        console.log(error) ;
    }
}





export const editCommentReply = (course_id, content_id, edit_data, child_indices, comment_id) => async (dispatch) => {
    try{    
        // This is received internally by reducer (will happen quickly)
        dispatch({type: EDIT_COMMENT_REPLY, payload: {edit_data, content_id, comment_id, child_indices}}) ; 
        var edit_comment_details  = {}
        edit_comment_details["edit_data"] = edit_data // The edited comment
        edit_comment_details["content_id"] = content_id // The ID of the content item (to look up in database)
        edit_comment_details["comment_id"] = comment_id // The ID of the original comment
        edit_comment_details["child_indices"] = child_indices
        // // // This sends same info to database
        await api.editCommentReply(course_id, edit_comment_details) ; 
    } catch (error) {
        console.log(error) ;
    }
}




export const deleteCommentReply = (course_id, content_id, child_indices, comment_id) => async (dispatch) => {
    try{    
        // This is received internally by reducer (will happen quickly)
        dispatch({type: DELETE_COMMENT_REPLY, payload: {content_id, comment_id, child_indices}}) ; 

        var update_comment_details  = {}
        update_comment_details["content_id"] = content_id // The ID of the content item (to look up in database)
        update_comment_details["comment_id"] = comment_id // The ID of the original comment
        update_comment_details["child_indices"] = child_indices
        // // This sends same info to database
        await api.deleteCommentReply(course_id, update_comment_details) ; 
    } catch (error) {
        console.log(error) ;
    }
}



export const upDownVoteComment = (id, updownvote_comment_details, progress) => async (dispatch) => {
    try{
        // Make local changes to content upvote count
        dispatch({type: UPDATE_UPDOWNVOTE_TOTAL, payload: {child_indices:updownvote_comment_details.child_indices, 
                                                            root_comment_id:updownvote_comment_details.root_comment_id, 
                                                            increment:updownvote_comment_details.increment,
                                                            content_id:updownvote_comment_details.content_id}})
        // Make local changes to content upvote count
        dispatch({type: STORE_PROGRESS_UPDOWNVOTE, payload: progress})

        // Send details to server
        await api.upDownVoteComment(id, updownvote_comment_details)
    } catch (error) {
        console.log(error) ;
    }
} 
